import React from "react"

//this code might need work

const SlidesEmbed = ({ node }) => {
    const slides_link_label = node.data.target.fields.linkLabel["en-US"]
    const slide_link = node.data.target.fields.link["en-US"]
    const slides_image = node.data.target.fields.slideImage["en-US"].fields.file["en-US"].url
    const slides_description = node.data.target.fields.slideImage["en-US"].fields.description
    return (
        <div className="articleContent articleContent--slide">
            <h4 className="articleContent--slide__label">
                <a href={`/${slide_link}`}>{slides_link_label}</a>
            </h4>

            <img className="articleContent--slide__image" src={slides_image} alt={slides_description} loading="lazy" />
        </div>
    )
}

export default SlidesEmbed
